import { render } from "./ThinkingAreaForm.vue?vue&type=template&id=00a20566"
import script from "./ThinkingAreaForm.vue?vue&type=script&lang=js"
export * from "./ThinkingAreaForm.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__